import { Card } from 'components/common';
import { Col } from 'components/common/Grid';
import { TextRulingForm } from 'containers/common/site/texts/TextRulingForm';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { FormGridBody } from '../../../../components/common/Forms/Forms.styled';
import { PromptWithBeforeUnload } from '../../../../components/Form/PromptWithBeforeUnload';
import { useIsDirty } from '../../../../hooks/form/useIsDirty';
import useAttributesForm from '../../../../hooks/useAttributesForm';
import { SiteData } from '../../../../types/sites';
import {
  ISitePreferencesProps,
  SITE_PREFERENCES_FORM_ID,
} from '../SitePreferences';
import {
  useMergeSiteFormHooks,
  useSiteFormSubmit,
} from '../SitePreferencesHooks';
import { useTextRulingFormHooks } from './TextRulingFormHooks';
import {
  TextsPreferencesFormFieldValues,
  UseTextsPreferencesFormHooksReturn,
} from './TextsPreferencesHooks';

type Props = ISitePreferencesProps & {
  site: SiteData;
};

export const TextsPreferences = (props: Props) => {
  const { site } = props;
  const formPartsHooks: UseTextsPreferencesFormHooksReturn[] = [
    useTextRulingFormHooks({ site }),
  ];

  const { defaultValues, restAttributes, beforeSubmit } = useMergeSiteFormHooks(
    { site, hooks: formPartsHooks },
  );

  const theForm = useForm<TextsPreferencesFormFieldValues>({
    defaultValues,
  });

  useEffect(() => {
    theForm.reset(defaultValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [site]);

  const attributesForm = useAttributesForm<TextsPreferencesFormFieldValues>({
    theForm,
    currentAttrs: site.attributes,
    restAttributes,
    dep: [site],
  });

  const isDirty = useIsDirty(attributesForm.formState);

  const submitForm = useSiteFormSubmit({
    beforeSubmit,
    ...props,
    ...attributesForm,
  });

  return (
    <FormGridBody id={SITE_PREFERENCES_FORM_ID} onSubmit={submitForm}>
      <PromptWithBeforeUnload when={isDirty}></PromptWithBeforeUnload>
      <Col sm={6}>
        <Card mb="var(--s4)">
          <TextRulingForm attributesForm={attributesForm} {...props} />
        </Card>
      </Col>
    </FormGridBody>
  );
};
